import { useEffect, useState } from "react";
import { optionsType } from "./MultiSelect";
import { Controller, set, useWatch } from "react-hook-form";
import { selectStyle, selectTheme } from "../../styles/selectStyles";
import Select from "react-select";
import SelectOption from "./SelectOption";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
type OptionsType = { id: number; name: string };
type SelectProps = {
  control: any;
  errors: any;
  setValue: any;
  trigger: any;
  name: string;
  isRequired?: boolean;
  root?: string;
  isfixedRootValue?: boolean;
  fixedRootValue?: any;
  fetchFunction: any;
  isMulti?: boolean;
  isDisabled?: boolean;
};
const SearchableSelect = ({
  control,
  errors,
  setValue,
  isRequired = false,
  trigger,
  root = "club_ids",
  isfixedRootValue,
  fixedRootValue = "",
  name,
  isDisabled = false,
  fetchFunction,
}: SelectProps) => {
  const selectedClubs =
    useWatch({
      control,
      name: root,
      disabled: isfixedRootValue,
      defaultValue: fixedRootValue || [],
    }) || [];
  const clubIds =
    selectedClubs.length > 0
      ? selectedClubs.map((club: OptionsType) => club.id)
      : "";

  const { placeHolders }: DictionaryType = useGetDictionary();
  const [options, setOptions] = useState<optionsType[]>([]);
  const selectedServices = useWatch({ control, name }) || [];

  const [query, setQuery] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setOptions([]);
    setLoading(true);
  }, [fixedRootValue]);
  const { data, isSuccess, isError } = fetchFunction(
    { name: query, club_ids: clubIds, club_id: fixedRootValue },
    { skip: !loading }
  );

  useEffect(() => {
    setOptions(selectedServices);
    setLoading(true);
  }, [selectedClubs]);

  useEffect(() => {
    if (isSuccess && data) {
      const fetchedValues = data.data.map((item: OptionsType) => item);
      setOptions((prev) => {
        const newValues = [...prev];
        fetchedValues.forEach((item: any) => {
          if (!newValues.find((existing) => existing.id === item.id)) {
            newValues.push(item);
          }
        });
        return newValues;
      });
      setLoading(false);
    }
  }, [isSuccess, data]);

  if (isError) {
    setLoading(false);
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired,
      }}
      render={({ field }) => (
        <Select
          components={{
            IndicatorSeparator: () => null,
            ClearIndicator: () => null,
            Option: SelectOption,
          }}
          isDisabled={isDisabled}
          styles={selectStyle}
          classNamePrefix="react-select"
          theme={selectTheme}
          {...field}
          isMulti
          options={options}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id?.toString()}
          onChange={(selected) => {
            const selectedOptions = selected.map((item: any) => ({
              id: item.id,
              name: item.name,
            })); // Keep structure intact
            field.onChange(selectedOptions); // Update form state with full objects
            setValue(name, selectedOptions); // Sync with form state
            trigger(name); // Trigger validation
          }}
          onInputChange={(inputValue, { action }) => {
            if (action === "input-change") {
              setQuery(inputValue);
            }
          }}
          isLoading={loading}
          value={field.value}
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          placeholder={placeHolders.select}
        />
      )}
    />
  );
};
export default SearchableSelect;
